import qs from 'qs'

const isEmpty = (value) => {
    if (value == null) return true
    if (typeof value === 'string') return value.trim() === ''
    if (Array.isArray(value)) return value.length === 0
    if (typeof value === 'object') return Object.keys(value).length === 0
    return false
}

const toCleanQuery = (query = {}) => {
    return Object.fromEntries(Object.entries(query).filter(([, value]) => !isEmpty(value) && value !== false))
}

export const useCraftNavigation = () => {
    const reloadTo = (url) => {
        window.location.href = url
    }

    const reloadToPath = (path, query = {}) => {
        const cleanQuery = toCleanQuery(query)
        const queryString = qs.stringify(cleanQuery, {
            encodeValuesOnly: true,
            skipNulls: true,
            arrayFormat: 'brackets'
        })
        reloadTo(queryString ? `${path}?${queryString}` : path)
    }

    return {
        reloadTo,
        reloadToPath
    }
}
